import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import base from "./modules/configurator/base";
import canopy from "./modules/configurator/canopy";
import frame from "./modules/configurator/frame";
import global from "./modules/global";
import layout from "./modules/configurator/layout";
import shape from "./modules/configurator/shape";
import stock from "./modules/configurator/stock";
import fabric from "./modules/configurator/fabric";
import user from "./modules/user";
import surcharge from "./modules/surcharge";
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: "shadeDesigner"
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: undefined,
  mutations: {},
  actions: {},
  modules: {
    global,
    user,
    canopy,
    base,
    frame,
    layout,
    shape,
    stock,
    fabric,
    surcharge
  },
  plugins: [vuexLocal.plugin]
});
